import Store from '../wrappers/Store';
function isGoods(product) {
    return product.is_goods === null || !!product.is_goods;
}
/** Inventory accounting is on for the venue: its setting, or the contracted module. */
export function isInventoryAccountingActive() {
    const tenant = Store.get('tenant');
    const modules = Store.get('modules');
    return !!tenant?.venue?.settings?.use_inventory_accounting || !!modules?.inventory_accounting;
}
/** Inventory accounting covers this product: goods, made or sold. */
export function inventoryAccountingAppliesTo(product) {
    return isInventoryAccountingActive() && !!product && (isGoods(product) || !!product.is_made || !!product.is_sold);
}
/** Goods that aren't sold (ingredients) have no selling price; services always have one. */
export function hasSellingPrice(product) {
    return !isGoods(product) || !!product.is_sold;
}
/**
 * The selling price (and the product's pricelist prices) can't be edited: the product has no
 * selling price, or inventory accounting keeps the price of goods unless the venue allows
 * price changes on existing products. Services are never locked, and neither is a made
 * product: it is never bought in through a kalkulacija, so inventory accounting never sets
 * its price (as in v8).
 */
export function isSellingPriceLocked(product) {
    if (!isGoods(product))
        return false;
    const tenant = Store.get('tenant');
    const priceChangeEnabled = !!tenant?.venue?.settings?.inventory_accounting_price_change_enabled;
    return !hasSellingPrice(product)
        || (inventoryAccountingAppliesTo(product) && !product.is_made && !(product.id && priceChangeEnabled));
}
/** The lowest price the form accepts: 0 under inventory accounting, otherwise 0.01. */
export function minSellingPrice(product) {
    return inventoryAccountingAppliesTo(product) ? 0 : 0.01;
}
/** Pricelist prices are edited only with the pricelists module, outside retail and inventory accounting. */
export function arePricelistPricesEnabled() {
    const tenant = Store.get('tenant');
    const modules = Store.get('modules');
    return !tenant?.venue?.settings?.use_inventory_accounting && !Store.get('isRetail') && !!modules?.pricelists;
}
//# sourceMappingURL=productPriceRules.js.map